import { TextArea } from '@rbilabs/universal-components';

export const InstructionsTextarea = TextArea.withConfig({
  width: 'full',
  fontSize: 'md',
  borderWidth: '1px',
  borderColor: Styles.color.grey.four,
  borderRadius: Styles.borderRadius,
  paddingY: '$4',
  paddingLeft: '$4',
  paddingRight: '$2',
  marginRight: '$0',
  marginTop: '$2.5',
  marginBottom: '$5',
  _focus: {
    outline: 'none',
    borderColor: Styles.color.primary,
  },
});
